/* TK 2026-08-22 perf — nahrivani PDP galerie.

   VYCHOZI STAV: prvni slide je `loading="eager"` + `fetchpriority="high"`,
   vsechny ostatni `loading="lazy"` (blocks/_product-media-gallery.liquid).
   Diky tomu hlavni obrazek nesoupeři o pasmo s dalsimi ~15 snimky.

   ⚠️ LAZY SAMO O SOBE JE REGRESE. Kdyz slidy zustanou lazy nadobro, prvni
   PREPNUTI snimku zacne stahovat az v tu chvili a uzivatel to pozna driv nez
   jakekoli mereni. Prepnuti na `eager`, jakmile je hlavni obrazek stazeny,
   je proto POVINNA cast, ne volitelna.

   Co skript dela:
     1. az dojede hlavni snimek (`load` na prvnim <img>), prepne na eager
        slidy 2-8 — ty jsou na dosah jednoho-dvou kliknuti,
     2. po `load` stranky v idle case dozene i zbytek (parita s puvodnim
        inline skriptem, ktery prepinal vsechno),
     3. najeti mysi / dotyk / klik na thumbnail nahreje sousedni slidy
        (dulezite pro thumbnaily za osmym, ktere krok 1 nepokryva) a zvedne
        prioritu samotneho nahledu.

   Zoom dialog se VYNECHAVA zamerne (`img.closest('zoom-dialog')`) — otevira se
   az na kliknuti a je to dalsich ~15 obrazku ve vysokem rozliseni.

   Selektory (overeno v MO markupu, ne prevzato z Horizonu):
     media-gallery                     blocks/_product-media-gallery.liquid:513
     slideshow-slide                   snippets/slideshow-slide.liquid:22
     img.product-media__image          snippets/product-media.liquid (class na image_tag)
     .slideshow-controls__thumbnail    snippets/slideshow-controls.liquid:107
     .dialog-thumbnails-list__thumbnail blocks/_product-media-gallery.liquid:845
     zoom-dialog                       blocks/_product-media-gallery.liquid (~817)
*/
(function () {
  var EAGER_AHEAD = 8; // kolik slidu nahrat hned po hlavnim obrazku

  // Sporici rezim / pomala sit: hlavni obrazek necháme, zbytek at si uzivatel
  // dotahne az kliknutim. Stejna logika jako v assets/tk-prefetch.js.
  var conn = navigator.connection;
  var frugal = !!(conn && (conn.saveData || (conn.effectiveType && conn.effectiveType !== '4g')));

  function slideImages() {
    return document.querySelectorAll('media-gallery slideshow-slide img.product-media__image');
  }

  function makeEager(img) {
    if (!img || img.loading !== 'lazy') return;
    if (img.closest('zoom-dialog')) return;
    img.loading = 'eager';
  }

  // 3) hover/dotyk/klik na thumbnail -> nahrej cilovy slide a jeho sousedy
  function warmAround(index) {
    var list = slideImages();
    for (var i = index - 1; i <= index + 1; i++) {
      if (i >= 0 && i < list.length) makeEager(list[i]);
    }
  }

  function onThumb(event) {
    var el = event.target;
    if (!el || !el.closest) return;
    var thumb = el.closest('.slideshow-controls__thumbnail, .dialog-thumbnails-list__thumbnail');
    if (!thumb || !thumb.parentNode) return;

    // Nahledy jsou samy o sobe eager, ale od devateho jedou s prioritou `auto`
    // (snippets/slideshow-controls.liquid). Kdyz na nej uzivatel miri, ma smysl
    // ho poslat dopredu fronty.
    var thumbImg = thumb.querySelector('img');
    if (thumbImg && !thumbImg.complete) thumbImg.fetchPriority = 'high';

    warmAround(Array.prototype.indexOf.call(thumb.parentNode.children, thumb));
  }

  // 1) jakmile je hlavni obrazek stazeny, pust prvnich EAGER_AHEAD slidu
  function releaseAfterHero() {
    var list = slideImages();
    var hero = list[0];
    if (!hero) return;

    var go = function () {
      var current = slideImages();
      for (var i = 1; i < current.length && i < EAGER_AHEAD; i++) makeEager(current[i]);
    };

    if (frugal) return;
    if (hero.complete && hero.naturalWidth) go();
    else hero.addEventListener('load', go, { once: true });
  }

  // 2) po `load` stranky v idle case dozen i zbytek galerie
  function releaseRest() {
    if (frugal) return;
    var list = slideImages();
    for (var i = 0; i < list.length; i++) makeEager(list[i]);
  }

  var idle =
    window.requestIdleCallback ||
    function (cb) {
      return setTimeout(cb, 500);
    };

  function boot() {
    releaseAfterHero();
    if (document.readyState === 'complete') idle(releaseRest);
    else window.addEventListener('load', function () { idle(releaseRest); }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Variant picker umi galerii prerenderovat (replaceWith) — nove <img> jsou
  // zase lazy. Posloucham jen, nic nedispatchuju (viz notes/features.md:
  // dispatchovat `variant:update` s vlastnim detailem rozbije Horizon).
  document.addEventListener('variant:update', function () {
    idle(function () {
      releaseAfterHero();
      releaseRest();
    });
  });

  // Delegace na document -> prezije prerender galerie i lightbox otevreny pozdeji.
  document.addEventListener('pointerenter', onThumb, true);
  document.addEventListener('touchstart', onThumb, { capture: true, passive: true });
  document.addEventListener('click', onThumb, true);
})();
